module.exports = __webpack_public_path__ + "img/pdf.721b34aa.svg";